const USER_TAG_REGEX = /@\[([^\]]+)\]\(([^)]+)\)/g;
const PROJECT_TAG_REGEX = /#\[([^\]]+)\]\(([^)]+)\)/g;

const normalizePlainTitle = (value) =>
  value
    .replace(USER_TAG_REGEX, (_full, display) => `@${display}`)
    .replace(PROJECT_TAG_REGEX, (_full, display) => `#${display}`)
    .replace(/\s+/g, " ")
    .trim();

const collectMatches = (regex, value) => {
  const matches = [];
  let match;
  while ((match = regex.exec(value)) !== null) {
    matches.push({
      display: match[1],
      id: match[2],
    });
  }
  return matches;
};

export const parseTaggingReferences = (markupValue = "") => {
  const userMentions = collectMatches(new RegExp(USER_TAG_REGEX), markupValue);
  const projectMentions = collectMatches(new RegExp(PROJECT_TAG_REGEX), markupValue);

  const lastUserMention = userMentions[userMentions.length - 1] || null;
  const lastProjectMention = projectMentions[projectMentions.length - 1] || null;

  return {
    title: normalizePlainTitle(markupValue),
    userMentions,
    projectMentions,
    lastUserMention,
    lastProjectMention,
  };
};
